/**
 * Format an integer room count for an `<input type="number">`: empty string
 * for 0/undefined (so the placeholder shows), otherwise the bare integer.
 * No commas — `type="number"` rejects them.
 *
 * @param value - Numeric count.
 * @returns Display string suitable for an `<input>` value.
 */
export function formatRoomCount(value: number | undefined): string {
  if (value === undefined || value === null || value === 0) return "";
  if (!Number.isFinite(value) || value < 0) return "";
  return String(Math.floor(value));
}

/**
 * Parse a user-typed string back to a non-negative integer. Floors
 * decimals, returns 0 for empty/invalid input.
 *
 * @param raw - String from an `<input>` change event.
 * @returns Sanitized non-negative integer.
 */
export function parseRoomCount(raw: string): number {
  if (!raw) return 0;
  const cleaned = raw.trim();
  if (!cleaned) return 0;
  const n = Number(cleaned);
  if (!Number.isFinite(n) || n < 0) return 0;
  return Math.floor(n);
}
